import { create } from 'zustand';

export interface BreadcrumbState {
  /**
   * Libellés dynamiques du fil d'Ariane, indexés par chemin cumulatif
   * (ex: '/missions-freelance/recXXX' -> 'CTO - Loïc Calvy chez Hermès').
   * Une page peut enregistrer un libellé lisible pour remplacer le libellé générique ("Détail").
   */
  labels: Record<string, string>;
  setLabel: (path: string, label: string) => void;
  clearLabel: (path: string) => void;
}

export const useBreadcrumbStore = create<BreadcrumbState>()((set) => ({
  labels: {},
  setLabel: (path, label) =>
    set((state) => (state.labels[path] === label ? state : { labels: { ...state.labels, [path]: label } })),
  clearLabel: (path) =>
    set((state) => {
      if (!(path in state.labels)) return state;
      const next = { ...state.labels };
      delete next[path];
      return { labels: next };
    }),
}));
